<section class="task-card" data-test="financial-agreement-task-card" aria-labelledby="financial-agreement-task-card-headline">
  <div class="chip" data-test="financial-agreement-task-card-chip">
    <iris-icon name="error" [size]="iconSizes.SM" colorToken="$color-neutral-900"></iris-icon>
    <span>Action needed</span>
  </div>

  <div class="body">
    <p id="financial-agreement-task-card-headline" class="headline">
      Please sign our Financial Responsibility Agreement.
    </p>
    <p class="detail">
      You have a payment card on file. We need your agreement to our financial terms before it can be
      used for your sessions.
    </p>
  </div>

  <iris-checkbox [formControl]="agreedControl" data-test="financial-agreement-task-card-checkbox">
    I agree to the
    <a class="agreement-link" [href]="agreementUrl" target="_blank" rel="noopener">Financial Responsibility Agreement</a>,
    and authorize SonderMind to charge the payment card on file in accordance with those terms.
  </iris-checkbox>

  @if (errorCopy(); as copy) {
    <p class="error" role="alert" data-test="financial-agreement-task-card-error">{{ copy }}</p>
  }

  <button
    type="button"
    class="cta"
    [disabled]="!canSubmit()"
    [attr.aria-busy]="submitting() || null"
    (click)="sign()"
    data-test="financial-agreement-task-card-cta"
  >
    @if (submitting()) {
      Signing…
    } @else {
      Sign agreement
    }
  </button>
</section>
